import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getCoverageSplitLineage = {
  name: "getCoverageSplitLineage" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.object({
    splits: z.array(
      z.object({
        _id: zExt.objectId(),
        name: z.string().optional(),
        generation: z.number(),
        concluded: z
          .object({ selectedTreatmentId: zExt.objectId() })
          .optional(),
        active: z.boolean(),
        startDate: z.date().optional(),
        endDate: z.date().nullable().optional(),
      }),
    ),
  }),
};
